import React from 'react';
import { CustomSVG } from '../../CustomSVG/CustomSVG';
import EditSvg from '../../../assets/icons/app/edit.svg?raw';

export const EditIcon = (props) => <CustomSVG svg={EditSvg} preserveColors appIconSmall {...props} />;
